import script from "./IPChangeHistoryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./IPChangeHistoryModal.vue?vue&type=script&setup=true&lang=js"

import "./IPChangeHistoryModal.vue?vue&type=style&index=0&id=25e16d8a&scoped=true&lang=css"
import "./IPChangeHistoryModal.vue?vue&type=style&index=1&id=25e16d8a&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25e16d8a"]])

export default __exports__